module.exports = __webpack_public_path__ + "img/building95-3.223bd618.jpg";